export const getAdContextCookie = () => {
  if (!IS_BROWSER) {
    return {};
  }
  const cookies = IS_BROWSER ? document.cookie : '';
  const cookieData = cookies.split(';').find(val => /^pj:ads/.test(val.trim()));
  const cookieValue = (cookieData || '').replace(/\s?pj:ads=/, '');
  try {
    return { ...JSON.parse(atob(cookieValue)) };
  } catch (err) {
    return {};
  }
};

export const setAdContextCookie = value => {
  if (!IS_BROWSER) {
    return;
  }
  const cookieValue = btoa(
    JSON.stringify({ ...getAdContextCookie(), ...value })
  );
  document.cookie = `pj:ads=${cookieValue}`;
};

const getQueryParam = (query, param) => {
  const testRegexp = new RegExp(`[&?]${param}\\b`);
  if (!testRegexp.test(query)) {
    return undefined;
  }
  const matchRegexp = new RegExp(`[&?]${param}=([^&]+)`);
  const match = query.match(matchRegexp);
  return match && match.length > 1 ? match[1] : null;
};

export const updateAdContextCookie = () => {
  if (!IS_BROWSER) {
    return;
  }
  const { search } = window.location;
  const values = ['ad_service', 'ad_debug'].reduce((result, param) => {
    const paramValue = getQueryParam(search, param);
    return paramValue === undefined
      ? result
      : { ...result, [param.substr(3)]: paramValue };
  }, {});
  // Special case for appnexus test crew
  if (search.indexOf('appnexus=1') > -1) {
    values.service = 'appnexus';
  }
  if (Object.keys(values).length) {
    setAdContextCookie(values);
  }
};

export default {
  getAdContextCookie,
  setAdContextCookie,
  updateAdContextCookie,
};
